import { switchMap, map } from 'rxjs/operators';
import { Fetch } from '@app/models/fetch';
import { AuthState } from '@app/auth/auth.state';
import { WaterStatus, ActiveLeak } from '@app/models/water-status/water-status.model';
import { Subject, BehaviorSubject, Observable, pipe } from 'rxjs';
import { UnitService } from '@app/utils/unit.service';
import { DateTime } from 'luxon';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../../auth/auth.state";
import * as i3 from "../../utils/unit.service";
export class WaterStatusService {
    constructor(fetch, authState, units) {
        this.fetch = fetch;
        this.authState = authState;
        this.units = units;
        this._activeLeak = new BehaviorSubject(null);
        this.activeLeak = this._activeLeak.asObservable(); // eslint-disable-line
        this._scrollToLeak = new BehaviorSubject(null);
        this.scrollToLeak = this._scrollToLeak.asObservable(); // eslint-disable-line
    }
    getWaterStatusPipe() {
        return pipe(switchMap((loc) => this.getWaterStatus(loc.ws.id, this.units.get().query)));
    }
    getWaterStatus(deviceID, units) {
        return this.fetch
            .getAll(`//users/${this.authState.userID()}/devices/${deviceID}/query/active`)
            .req.pipe();
    }
    getLeakStatusPipe() {
        return pipe(switchMap((loc) => this.getLeakStatus(loc.ws.id)));
    }
    getLeakStatus(deviceID) {
        return this.fetch
            .getAll(`//users/${this.authState.userID()}/devices/${deviceID}/leaks/active`)
            .req.pipe(map((res) => {
            res.data[0].device_id = deviceID;
            return res;
        }));
    }
    getActiveLeak(deviceID, leakID) {
        this.fetch
            .getAll(`//users/${this.authState.userID()}/devices/${deviceID}/leaks/${leakID}`)
            .model(ActiveLeak)
            .subscribe((data) => {
            this._activeLeak.next(data);
        });
    }
    removeLeak() {
        this._activeLeak.next(null);
    }
    buildLeakDisplayData(startStopString, totalGpm, totalGallons, leakDuration, leakEndDate) {
        const leakDisplayData = {
            startStopString: startStopString,
            flowRate: this.parseValueFromString(totalGpm),
            total: this.parseValueFromString(totalGallons),
            duration: leakDuration,
            durationString: leakEndDate === null ? 'This leak has been running for' : 'This leak ran for',
        };
        return leakDisplayData;
    }
    parseValueFromString(input) {
        const flowrate = input.split('.');
        if (flowrate[0] === '0') {
            return '.' + flowrate[1].slice(0, 2);
        }
        else {
            return flowrate[0] + '.' + flowrate[1].slice(0, 2);
        }
    }
    getStartStopString(leakStart, leakEnd) {
        const start = DateTime.fromISO(leakStart);
        if (leakEnd === null) {
            return `This leak started on ${start.toFormat('EEE MMM dd, yyyy')} at ${start.toFormat('hh:mm a')} and is currently active.`;
        }
        else {
            const end = DateTime.fromISO(leakEnd);
            return `This leak ended on ${end.toFormat('EEE MMM dd, yyyy')} at ${end.toFormat('hh:mm a')}`;
        }
    }
    getLeakDuration(leakStart, leakEnd) {
        const start = DateTime.fromISO(leakStart);
        let end;
        if (leakEnd === null) {
            end = DateTime.fromJSDate(new Date());
        }
        else {
            end = DateTime.fromISO(leakEnd);
        }
        const duration = end.diff(start, ['months', 'days', 'hours', 'minutes']).normalize().toObject();
        if (duration.months > 0) {
            duration.months = duration.months.toFixed();
        }
        if (duration.days > 0) {
            duration.days = duration.days.toFixed();
        }
        if (duration.hours > 0) {
            duration.hours = duration.hours.toFixed();
        }
        if (duration.minutes > 0) {
            duration.minutes = duration.minutes.toFixed();
        }
        return duration;
    }
    triggerScrollToLeak() {
        this._scrollToLeak.next(true);
    }
}
WaterStatusService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WaterStatusService_Factory() { return new WaterStatusService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.AuthState), i0.ɵɵinject(i3.UnitService)); }, token: WaterStatusService, providedIn: "root" });
